import React from 'react';
export function Mirrors() {
  const cards = [{
    title: 'Bathroom & Vanity Mirrors',
    copy: 'Custom mirrors sized and styled for bathrooms, vanities and dressing areas.'
  }, {
    title: 'Home Gym & Wall Mirrors',
    copy: 'Large wall mirrors and gym mirrors that brighten the room and make spaces feel larger.'
  }, {
    title: 'Table Tops & Glass Shelves',
    copy: 'Custom table tops and shelves for furniture, desks, cabinets, display areas and home projects.'
  }, {
    title: 'Decorative & Patterned Glass',
    copy: 'Etched glass, patterned glass, tinted glass, door inserts and specialty interior glass.'
  }];
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-slate-50 border-y border-slate-200" data-id="element-111">
      <div className="max-w-7xl mx-auto" data-id="element-112">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-113">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 tracking-tight mb-6" data-id="element-114">
            Custom Mirrors, Table Tops & Interior Glass
          </h2>
          <p className="text-lg text-slate-600" data-id="element-115">
            Kosin’s Glass can help enhance your home with custom mirrors, glass
            table tops, shelves, cabinet glass, decorative glass and specialty
            glass. Whether you need a bathroom mirror, home gym mirror, wall
            mirror, etched glass, patterned glass or replacement mirror, the
            team can help measure, design and fabricate the right solution.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-116">
          {cards.map((card, idx) => <div key={idx} className="bg-white rounded-2xl p-6 shadow-soft border border-slate-100" data-id="element-117">
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-118">
                {card.title}
              </h3>
              <p className="text-slate-600" data-id="element-119">{card.copy}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-120">
          <a href="/customglassmirrors.html" className="inline-flex items-center justify-center bg-white border-2 border-brandBlue-600 text-brandBlue-600 hover:bg-brandBlue-50 font-bold text-lg py-3 px-8 rounded-xl transition-colors" data-id="element-121">
            View Custom Mirrors
          </a>
        </div>
      </div>
    </section>;
}